import { Drawer, Tabs } from '@pankod/refine-antd'
import React, { useCallback, useState } from 'react'
import { useInvalidate } from '@pankod/refine-core'

import UploadParticipantTableList from '@resources/lms-management/participant-management/blocks/UploadParticipantTableList'
import UploadParticipantDataButton from './UploadParticipantDataButton'
import DownloadTemplateButton from '@resources/lms-management/program/program-setup/blocks/bulk-import-participant/DownloadTemplateButton'

export const useBulkImportParticipantDrawer = () => {
  const [showId, setShowId] = useState<{
    show: boolean
    programId: string | number | string[]
    localProgramId: string | number | string[]
  }>({ show: false, programId: '', localProgramId: '' })
  const onClose = useCallback(() => {
    setShowId((state) => ({
      ...state,
      show: false,
    }))
  }, [])

  return {
    show: (
      programId: number | string | string[],
      localProgramId: number | string | string[],
    ) => {
      setShowId({ show: true, programId, localProgramId })
    },
    visible: !!showId.show,
    programId: showId.programId,
    localProgramId: showId.localProgramId,
    onClose,
  }
}

type BulkImportParticipantDrawer = {
  visible: boolean
  onClose: () => void
  programId?: string | number | string[]
  localProgramId?: string | number | string[]
}

const BulkImportParticipantDrawer = ({
  onClose,
  visible,
  programId,
  localProgramId,
}: BulkImportParticipantDrawer) => {
  const invalidate = useInvalidate()
  return (
    <Drawer
      title="Bulk Import Partisipan ke Program Lokal"
      visible={visible}
      onClose={onClose}
      destroyOnClose
      maskClosable={false}
      width="70%"
      extra={
        <div className="flex gap-2">
          <DownloadTemplateButton
            columns={['email', 'user_id', 'name', 'role', 'kelas']}
            filename={`import_program_${programId}_program_local_${localProgramId}`}
          />
          <UploadParticipantDataButton
            programId={programId}
            localProgramId={localProgramId}
            onSuccess={() => {
              invalidate({
                resource: `programs/${programId}/participant-queue`,
                dataProviderName: 'lms',
                invalidates: ['list'],
              })
            }}
          />
        </div>
      }
    >
      <Tabs type="card" destroyInactiveTabPane>
        <Tabs.TabPane key="queue" tab="Daftar Antrian Import">
          <UploadParticipantTableList
            type="kelas-enrollment"
            variant="queue"
            programId={programId}
            localProgramId={localProgramId}
          />
        </Tabs.TabPane>
        <Tabs.TabPane key="failed" tab="Daftar Gagal Import">
          <UploadParticipantTableList
            type="kelas-enrollment"
            variant="failed"
            programId={programId}
            localProgramId={localProgramId}
          />
        </Tabs.TabPane>
      </Tabs>
    </Drawer>
  )
}

export default BulkImportParticipantDrawer
